import type { IOrganizationCommissionLimits } from './OrganizationCommissionLimits.interface';
import OrganizationCommissionLimitsAssetFinance from './OrganizationCommissionLimitsAssetFinance';

export default class OrganizationCommissionLimits implements IOrganizationCommissionLimits {
  assetFinance: OrganizationCommissionLimitsAssetFinance;

  static build = (data: IOrganizationCommissionLimits) =>
    new OrganizationCommissionLimits(data);

  static blank = () => new OrganizationCommissionLimits();

  /**
   * Constructor
   * @param {IOrganizationCommissionLimits} data
   */
  constructor(data?: IOrganizationCommissionLimits) {
    this.assetFinance = new OrganizationCommissionLimitsAssetFinance(data?.assetFinance);
  }
}
